import React, {useState, useEffect, useRef, useContext} from 'react';
import { InputWrapper } from './styled';
import { PredictiveContext } from './PredictiveConstructor';

interface Props {
  handleRef?: Function;
  getResults?: Function;
  handleChange?: Function;
  handleClick?: Function;
  handleKeyDown?: Function;
  handleBlur?: Function;
  value?: string;
  id?: string;
  minCharacter?: number;
  handleChangeInput?: Function;
  disabled?: boolean;
}

export const PredictiveInput: React.FC<Props> = ({
  handleRef,
  getResults,
  handleChange,
  handleClick,
  handleKeyDown,
  handleBlur,
  value,
  id,
  minCharacter,
  handleChangeInput,
  disabled
}) => {

  const { dataList } = useContext(PredictiveContext);
  const [suggestionsList, setSuggestionsList] = useState([]);
  let currentValue = '';
  const refInput = useRef(null);

  useEffect(() => {
    getResults && getResults(suggestionsList);
  }, [suggestionsList]);

  useEffect(() => {
    handleRef && handleRef(refInput);
  })
;
  const handleChangeProp = e => {
    currentValue = e.target.value;
    handleChange && handleChange(currentValue);
    handleChangeInput && handleChangeInput(e);
    if (dataList && currentValue.length >= minCharacter) {
      setSuggestionsList(
        dataList.filter(suggestion =>
          suggestion.alias
            .toLowerCase()
            .indexOf(currentValue.toLowerCase()) > -1)
      )
    } else {
      setSuggestionsList([]);
    }
  }

  return(
    <InputWrapper
      autoComplete="off"
      disabled={disabled}
      id={id}
      ref={refInput}
      value={value}
      minCharacter={minCharacter}
      onChange={handleChangeProp}
      onKeyDown={e => handleKeyDown && handleKeyDown(e)}
      onBlur={() => handleBlur && handleBlur()}
      onClick={e => handleClick && handleClick(e)} />
)};

PredictiveInput.defaultProps = {
  minCharacter: 3
}
